import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  constructor(private translate: TranslateService) {

  }


  // Method to change language
  changeLanguage(lang: string) {
    if (this.translate.getLangs().includes(lang)) {
      this.translate.use(lang);
      // For RTL support
      document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
      // Save the language preference
      localStorage.setItem('preferred_lang', lang);
    }
  }

  // Method to get the current language
  getCurrentLanguage(): string {
    return this.translate.currentLang || this.translate.getDefaultLang();
  }

  translateKey(key: string): string {
    return this.translate.instant(key);
  }

  onTranslationChange(callback: (lang: string) => void) {
    this.translate.onLangChange.subscribe((event) => {
      callback(event.lang);
    });
  }

  
}
